import { call, put, select } from 'redux-saga/effects';

import api from 'api';

import { joinBranchContentFinished } from '../actions';

import { UserStore } from '../../user/types';

import { selectCurrentUser } from '../../user/selectors';

export function* joinBranchContent() {
    try {
        const { w2a_branch }: UserStore = yield select(selectCurrentUser);

        yield call(api.personalPlan.joinBranchContent, { branch: w2a_branch });
        yield put(joinBranchContentFinished());
    } catch (error) {
        console.error('Join Branch Content Error', error);
    } finally {
        yield put(joinBranchContentFinished());
    }
}
